import React from "react";
import {faBorderAll, faSquareRootAlt, faStream, faThLarge} from "@fortawesome/free-solid-svg-icons";
import routes from "../../../routes";
import {NavLink as BaseNavLink} from "react-router-dom";
import Icon from "../../Shared/Icon";
import mainMenu from "./MainMenu.module.scss"

const NavLink = ({ route: { path, name }, icon, styles = {}, onClick = () => {} }) => (
  <BaseNavLink
    to={path}
    className={styles.link || mainMenu.link}
    activeClassName={styles.active || mainMenu.active}
    target="_self"
    onClick={onClick}
  >
    <Icon use={icon} classes="small" className={styles.icon || mainMenu.icon} />
    {name}
  </BaseNavLink>
);

const MainMenu = ({styles = {}, close = () => {} }) => {
  return(
    <>
      <NavLink icon={faBorderAll} route={routes.dashboard} styles={styles} onClick={close} />
      <NavLink icon={faThLarge} route={routes.boards} styles={styles} onClick={close} />
      <NavLink icon={faStream} route={routes.monthlyView} styles={styles} onClick={close} />
      {/* <NavLink icon={faCalendar} route={routes.calendar} styles={styles} />
      <NavLink icon={faWrench} route={routes.templates} styles={styles} /> */}
      <NavLink icon={faSquareRootAlt} route={routes.scribbler} styles={styles} onClick={close} />
    </>
  )
}

export default MainMenu;
